// extracted by mini-css-extract-plugin
module.exports = {"receipt-refund-reason":"_2gc1jt1Saq-Cef_Lfn6IBb","truncate-refund-reason":"_3N5tf_ypR7vFAUzOT-YENV"};